import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { TranslateService } from '@ngx-translate/core';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermServicesPage } from '../term-services/term-services';
import { RefundPolicyPage } from '../refund-policy/refund-policy';
import { SingleSurveyPage } from '../survey/survey';
import { CreateTechSurveyPage } from '../create-tech-survey/create-tech-survey';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingProvider } from '../../providers/loading/loading';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import swal from 'sweetalert';
import { AlertProvider } from '../../providers/alert/alert';
import { HomePage } from '../home/home';
//import * as Survey from 'survey-angular';
import { Http } from '@angular/http';
import { Geolocation } from '@ionic-native/geolocation';



@Component({
  selector: 'page-tech-survey',
  templateUrl: 'tech-surveys.html',
})
export class TechSurveyPage {
  errorMessage = '';
  surveys = new Array;
  loadedsurveys = new Array;
  lat= 0;
  long = 0;
  disableButton = false;
  contact = {self_surveyURL:'',customers_telephone:'',delivery_lastname:'',delivery_firstname:'',companyname:'',customer_id:0};
  constructor(
    public navCtrl: NavController,
    public shared: SharedDataProvider,
    public modalCtrl: ModalController,
    public config: ConfigProvider,
    public navParams: NavParams,
    public loading: LoadingProvider,
    public iab: InAppBrowser,
    translate: TranslateService,
    public http: Http,
    private geolocation: Geolocation,
    public alert: AlertProvider
  ) {
  }


openCreateTechSurvey(){
  this.navCtrl.push(CreateTechSurveyPage, { });
  console.log("Create a new Tech Survey");
}

getItems(searchbar){
  // Reset items back to all of the items
  this.initializeItems();
  // set q to the value of the searchbar
  var q = searchbar.srcElement.value;

  // if the value is an empty string don't filter the items
   if (!q) {
     return;
   }

   this.surveys = this.surveys.filter((v) => {

 if(v.cust_streetname && q) {
   if (v.cust_streetname.toLowerCase().indexOf(q.toLowerCase()) > -1) {
     return true;
   }
   return false;
 }
});


};

initializeItems(): void {
this.surveys = this.loadedsurveys;
}

ionViewWillEnter() {

}

DeleteSurvey(survey){
  console.log("Delete Survey:",survey);
  swal({title: "Delete Property ?",text:
  "Once deleted, you will not be able to recover this property!",icon: "error",buttons:
  ['Cancel','Ok']}).then((willDelete) => {
  if (willDelete) {
    var data = { property_id: survey.property_id };
      this.loading.show();
      this.http.post(this.config.url + 'deleteTechSurvey', data).map(res => res.json()).subscribe(data => {
        this.loading.hide();
        this.surveys.splice(this.surveys.indexOf(survey), 1);
      });


  }
})

}

showSurveyDetail(survey) {
  console.log("Go to Survey:",survey);
  this.navCtrl.push(SingleSurveyPage, { 'data': survey });

}

ngOnInit() {



this.geolocation.getCurrentPosition().then(pos => {
   this.lat = pos.coords.latitude;
   this.long = pos.coords.longitude;
   console.log("Got Lat:" + this.lat );
   console.log("Got Long:" + this.long );

}).catch(err => console.log(err));


console.log("Customer ID:",this.shared.customerData.customers_id)
var data = { ar_id: this.shared.customerData.customers_id };
  this.loading.show();
  this.http.post(this.config.url + 'getTechSurveys', data).map(res => res.json()).subscribe(data => {
    this.loading.hide();
    this.surveys = data.data;
    this.loadedsurveys = this.surveys;

    console.log("Survey:",this.surveys);



});

}
}



// WEBPACK FOOTER //
// ./src/pages/tech-surveys/tech-surveys.ts